import { Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { SpeedDial as MuiSpeedDial, SpeedDialIcon } from '@material-ui/lab';
import React, { ReactNode, useCallback, useState } from 'react';

export interface Props {
  children: ReactNode;
  label: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  speedDial: {
    '&.MuiSpeedDial-directionUp': {
      bottom: -1 * theme.spacing(5),
      right: theme.spacing(3)
    },
    'position': 'absolute'
  }
}));

export default function SpeedDial(props: Props) {
  const {children, label} = props;

  const [open, setOpen] = useState(false);

  const openSpeedDial = useCallback(() => setOpen(true), [setOpen]);
  const closeSpeedDial = useCallback(() => setOpen(false), [setOpen]);

  const classes = useStyles();

  return (
    <MuiSpeedDial
      ariaLabel={label}
      open={open}
      onOpen={openSpeedDial}
      onClose={closeSpeedDial}
      icon={<SpeedDialIcon/>}
      className={classes.speedDial}
    >
      {children}
    </MuiSpeedDial>
  );
}
